import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const pmsMetricsService = {
  getSummary,
  getTimeseries,
  getReaders,
  getPathologies,
  recompute
}

const API_BASE = apiRoute() + API_V1

// Builds a query string from defined options only (skips null/undefined).
function buildParams (opts = {}) {
  const params = new URLSearchParams()
  Object.entries(opts).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      params.set(key, value)
    }
  })
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

function getSummary (project, { subgroup = null, recentWindowDays = null, date = null } = {}) {
  return fetchWrapper.get(
    `${API_BASE}/staff/none/metrics/summary${buildParams({ subgroup, recentWindowDays, date })}`,
    { Project: project }
  )
}

function getTimeseries (project, { subgroup = null, recentWindowDays = null, interval = null, date = null, from = null, to = null } = {}) {
  return fetchWrapper.get(
    `${API_BASE}/staff/none/metrics/timeseries${buildParams({ subgroup, recentWindowDays, interval, date, from, to })}`,
    { Project: project }
  )
}

function getReaders (project, { subgroup = null, recentWindowDays = null, date = null } = {}) {
  return fetchWrapper.get(
    `${API_BASE}/staff/none/metrics/readers${buildParams({ subgroup, recentWindowDays, date })}`,
    { Project: project }
  )
}

function getPathologies (project, { subgroup = null, recentWindowDays = null, date = null } = {}) {
  return fetchWrapper.get(
    `${API_BASE}/staff/none/metrics/pathologies${buildParams({ subgroup, recentWindowDays, date })}`,
    { Project: project }
  )
}

function recompute (project, { force = false, recentWindowDays = 30 } = {}) {
  return fetchWrapper.post(
    `${API_BASE}/staff/none/metrics/recompute`,
    { force, recentWindowDays },
    { Project: project }
  )
}
